// // // // import axios from "axios";
// // // // import React, { useEffect, useState, useCallback } from "react";
// // // // import { Link } from "react-router-dom";
// // // // import { useUser } from "../UserContext";
// // // // import {
// // // //   FaBook,
// // // //   FaTasks,
// // // //   FaChartBar,
// // // //   FaEnvelope,
// // // //   FaUserCircle,
// // // //   FaClipboardList,
// // // //   FaExclamationTriangle,
// // // //   FaCheckCircle,
// // // // } from "react-icons/fa";

// // // // const StudentHome = () => {
// // // //   const [studentDetails, setStudentDetails] = useState(null);
// // // //   const { user } = useUser();
// // // //   // Since the dashboardStats values are static here, we declare them as a constant
// // // //   const [dashboardStats, setDashboardStats] = useState({  
// // // //     approvedAssignments: 0,
// // // //     rejectedAssignments: 0,
// // // //     assignedCases: 0,
// // // //   });

// // // //   const [topics, setTopics] = useState([]);
// // // //   const [loading, setLoading] = useState(true);
// // // //   const [error, setError] = useState(null);

// // // //   const fetchPendingReports = useCallback(async () => {
// // // //     setLoading(true);
// // // //     try {
// // // //       const apiUrl = (process.env.REACT_APP_API_URL || 'http://localhost:5001').trim();
// // // //       const { data } = await axios.get(
// // // //         `${apiUrl}/api/get-all-report-pdf`,
// // // //         { params: { username: user?.username } }
// // // //       );
// // // //       console.log("data", data);
      
      
// // // //       const approvedReports = data.filter(report => report.status === 'approved');
// // // //       console.log("approvedReports", approvedReports);
// // // //       const rejectedReports = data.filter(report => report.status === 'rejected');
// // // //       console.log("rejectedReports", rejectedReports);
      
// // // //       setDashboardStats(prev => ({
// // // //         ...prev,
        
// // // //         approvedAssignments: approvedReports.length,
// // // //         rejectedAssignments: rejectedReports.length
// // // //       }));
// // // //     } catch (err) {
// // // //       console.error('Error fetching reports:', err);
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   }, [user]);

// // // //   useEffect(() => {
// // // //     fetchPendingReports();
// // // //   }, [fetchPendingReports]);

// // // //   // ✅ Fetch Student Details from sessionStorage
// // // //   useEffect(() => {
// // // //     try {
// // // //       const userStr = sessionStorage.getItem("user");
// // // //       console.log("User from sessionStorage:", userStr);
// // // //       if (!userStr) {
// // // //         console.log("No user in sessionStorage");
// // // //         return;
// // // //       }

// // // //       const storedUser = JSON.parse(userStr);
// // // //       if (storedUser && storedUser.name) {
// // // //         setStudentDetails(storedUser);
// // // //       }
// // // //     } catch (error) {
// // // //       console.error("Error parsing user data:", error);
// // // //     }
// // // //   }, []);

// // // //   // Fetch Topics Data
// // // //   useEffect(() => {
// // // //     const fetchTopics = async () => {
// // // //       try {
// // // //         setLoading(true);
// // // //         const userStr = sessionStorage.getItem("user");
// // // //         if (!userStr) {
// // // //           throw new Error("User not logged in");
// // // //         }

// // // //         const storedUser = JSON.parse(userStr);
// // // //         const apiUrl = process.env.REACT_APP_API_URL;
// // // //         const response = await fetch(`${apiUrl}/api/student/topics/${storedUser.id}`);

// // // //         if (!response.ok) {
// // // //           throw new Error(`HTTP error! status: ${response.status}`);
// // // //         }

// // // //         const data = await response.json();
// // // //         setTopics(data);
// // // //         setError(null);
// // // //       } catch (err) {
// // // //         console.error("Error fetching topics:", err);
// // // //         setError("Failed to load topics data.");
// // // //       } finally {
// // // //         setLoading(false);
// // // //       }
// // // //     };

// // // //     if (studentDetails && studentDetails.id) {
// // // //       fetchTopics();
// // // //     }
// // // //   }, [studentDetails]);


// // // //   useEffect (()=>{
// // // //     const fetchAssignedCases = async () => {
// // // //     try{
// // // //         const response = await axios.get(
// // // //             `${process.env.REACT_APP_API_URL}/api/student/assignments/case/${user.id}`
// // // //           );
// // // //       console.log("response", response?.data.length);
// // // //       setDashboardStats(prev => ({
// // // //         ...prev,
// // // //         assignedCases: response?.data.length
// // // //       }));
// // // //     }
// // // //     catch(error){
// // // //         console.error("Error fetching assigned cases:", error);
// // // //     }
// // // //     };
// // // //     fetchAssignedCases();

// // // // },[user])

// // // //   return (
// // // //     <div className="flex flex-col items-center justify-center min-h-screen">
// // // //       {/* Main Card */}
// // // //       <div
// // // //         className="w-[90%] mx-auto bg-white p-10 shadow-2xl 
// // // //                    backdrop-blur-lg border border-gray-300 rounded-xl"
// // // //       >
// // // //         {studentDetails ? (
// // // //           <div className="text-center">
// // // //             {/* Profile Section */}
// // // //             <div className="flex flex-col items-center mb-8">
// // // //               <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
// // // //                 <FaUserCircle className="text-7xl drop-shadow-md" />
// // // //               </div>
// // // //               <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
// // // //                 <h1 className="text-3xl font-bold">
// // // //                   Welcome, {studentDetails.name}
// // // //                 </h1>
// // // //                 <p className="text-lg mt-1">{studentDetails.role}</p>
// // // //               </div>
// // // //             </div>

// // // //             {/* Statistics Section */}
// // // //             {loading ? (
// // // //               <p className="text-center text-gray-700">Loading topics data...</p>
// // // //             ) : error ? (
// // // //               <p className="text-center text-red-500">{error}</p>
// // // //             ) : (
// // // //               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
// // // //                 <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
// // // //                   <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
// // // //                   <h3 className="text-lg font-semibold">Available Modules</h3>
// // // //                   <p className="text-3xl font-bold">{topics.length + dashboardStats.assignedCases}</p>
// // // //                 </div>

// // // //                 <Link to="/student-dashboard/approved-assignments" className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block">
// // // //                   <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
// // // //                   <h3 className="text-lg font-semibold">Approved Assignments</h3>
// // // //                   <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
// // // //                 </Link>

// // // //                 <Link to="/student-dashboard/rejected-assignments" className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block">
// // // //                   <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
// // // //                   <h3 className="text-lg font-semibold">Rejected Assignments</h3>
// // // //                   <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
// // // //                 </Link>
// // // //               </div>
// // // //             )}

// // // //             {/* Action Cards */}
// // // //             <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
// // // //               <Link
// // // //                 to="/student-dashboard/topic"
// // // //                 className="group flex flex-col items-center justify-center gap-3 p-6 
// // // //                            bg-gradient-to-r from-blue-500 to-blue-400 text-white 
// // // //                            rounded-xl shadow-md transition-all duration-300 
// // // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
// // // //               >
// // // //                 <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // // //                 <span className="text-lg font-semibold tracking-wide">
// // // //                   My Courses
// // // //                 </span>
// // // //               </Link>

// // // //               <Link
// // // //                 to="/student-dashboard/courses/ongoing"
// // // //                 className="group flex flex-col items-center justify-center gap-3 p-6 
// // // //                            bg-gradient-to-r from-green-500 to-teal-400 text-white 
// // // //                            rounded-xl shadow-md transition-all duration-300 
// // // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
// // // //               >
// // // //                 <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // // //                 <span className="text-lg font-semibold tracking-wide">
// // // //                   Report Generation
// // // //                 </span>
// // // //               </Link>

// // // //               <Link
// // // //                 to="/student-dashboard/forums"
// // // //                 className="group flex flex-col items-center justify-center gap-3 p-6 
// // // //                            bg-gradient-to-r from-yellow-500 to-orange-400 text-white 
// // // //                            rounded-xl shadow-md transition-all duration-300 
// // // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
// // // //               >
// // // //                 <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // // //                 <span className="text-lg font-semibold tracking-wide">
// // // //                   Forums
// // // //                 </span>
// // // //               </Link>

// // // //               <Link
// // // //                 to="/student-dashboard/student-messages"
// // // //                 className="group flex flex-col items-center justify-center gap-3 p-6 
// // // //                            bg-gradient-to-r from-purple-500 to-pink-500 text-white 
// // // //                            rounded-xl shadow-md transition-all duration-300 
// // // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
// // // //               >
// // // //                 <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // // //                 <span className="text-lg font-semibold tracking-wide">
// // // //                   Messages
// // // //                 </span>
// // // //               </Link>
// // // //             </div>
// // // //           </div>
// // // //         ) : (
// // // //           <p className="text-center text-red-500">
// // // //             Access Denied. Please log in.
// // // //           </p>
// // // //         )}
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default StudentHome;
// // // // src/Components/StudentHome.js

// // // import React, { useEffect, useState, useCallback } from "react";
// // // import axios from "axios";
// // // import { Link } from "react-router-dom";
// // // import { useUser } from "../UserContext";
// // // import {
// // //   FaBook,
// // //   FaTasks,
// // //   FaChartBar,
// // //   FaEnvelope,
// // //   FaUserCircle,
// // //   FaClipboardList,
// // //   FaExclamationTriangle,
// // //   FaCheckCircle,
// // // } from "react-icons/fa";

// // // const StudentHome = () => {
// // //   const [studentDetails, setStudentDetails] = useState(null);
// // //   const { user } = useUser();

// // //   // Dashboard statistics
// // //   const [dashboardStats, setDashboardStats] = useState({
// // //     approvedAssignments: 0,
// // //     rejectedAssignments: 0,
// // //     assignedCases: 0,
// // //   });

// // //   // Topics list
// // //   const [topics, setTopics] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  1) Fetch all report PDFs so we can count approved vs. rejected
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   const fetchPendingReports = useCallback(async () => {
// // //     setLoading(true);
// // //     try {
// // //       const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
// // //       const { data } = await axios.get(`${apiUrl}/api/get-all-report-pdf`, {
// // //         params: { username: user?.username },
// // //       });

// // //       // Filter by status
// // //       const approvedReports = data.filter((report) => report.status === "approved");
// // //       const rejectedReports = data.filter((report) => report.status === "rejected");

// // //       setDashboardStats((prev) => ({
// // //         ...prev,
// // //         approvedAssignments: approvedReports.length,
// // //         rejectedAssignments: rejectedReports.length,
// // //       }));
// // //     } catch (err) {
// // //       console.error("Error fetching reports:", err);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }, [user]);

// // //   useEffect(() => {
// // //     if (user?.username) {
// // //       fetchPendingReports();
// // //     }
// // //   }, [fetchPendingReports]);

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  2) Load Student Details from sessionStorage
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   useEffect(() => {
// // //     try {
// // //       const userStr = sessionStorage.getItem("user");
// // //       if (!userStr) return;
// // //       const storedUser = JSON.parse(userStr);
// // //       if (storedUser && storedUser.name) {
// // //         setStudentDetails(storedUser);
// // //       }
// // //     } catch (err) {
// // //       console.error("Error parsing user data:", err);
// // //     }
// // //   }, []);

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  3) Fetch Topics Assigned to This Student
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   useEffect(() => {
// // //     const fetchTopics = async () => {
// // //       try {
// // //         setLoading(true);
// // //         const userStr = sessionStorage.getItem("user");
// // //         if (!userStr) {
// // //           throw new Error("User not logged in");
// // //         }
// // //         const storedUser = JSON.parse(userStr);
// // //         const apiUrl = process.env.REACT_APP_API_URL;
// // //         const response = await fetch(`${apiUrl}/api/student/topics/${storedUser.id}`);
// // //         if (!response.ok) {
// // //           throw new Error(`HTTP error! status: ${response.status}`);
// // //         }
// // //         const data = await response.json();
// // //         setTopics(data);
// // //         setError(null);
// // //       } catch (err) {
// // //         console.error("Error fetching topics:", err);
// // //         setError("Failed to load topics data.");
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     if (studentDetails && studentDetails.id) {
// // //       fetchTopics();
// // //     }
// // //   }, [studentDetails]);

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  4) Fetch Assigned “Case” Count
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   useEffect(() => {
// // //     const fetchAssignedCases = async () => {
// // //       try {
// // //         const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
// // //         const response = await axios.get(`${apiUrl}/api/student/assignments/case/${user.id}`);
// // //         setDashboardStats((prev) => ({
// // //           ...prev,
// // //           assignedCases: response.data.length,
// // //         }));
// // //       } catch (err) {
// // //         console.error("Error fetching assigned cases:", err);
// // //       }
// // //     };

// // //     if (user?.id) {
// // //       fetchAssignedCases();
// // //     }
// // //   }, [user]);

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  5) Filter Out Completed Topics
// // //   //     (Assumes each topic object has a field `status` with 'completed'
// // //   //      for finished modules. If your API uses a boolean like `isCompleted`,
// // //   //      replace this check accordingly.)
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   const visibleTopics = topics.filter((topic) => {
// // //     return topic.status?.toLowerCase() !== "completed";
// // //     // If your API uses a boolean flag instead, uncomment next line and remove above:
// // //     // return !topic.isCompleted;
// // //   });

// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   //  6) Render JSX
// // //   // ────────────────────────────────────────────────────────────────────────────
// // //   return (
// // //     <div className="flex flex-col items-center justify-center min-h-screen">
// // //       <div
// // //         className="w-[90%] mx-auto bg-white p-10 shadow-2xl
// // //                    backdrop-blur-lg border border-gray-300 rounded-xl"
// // //       >
// // //         {studentDetails ? (
// // //           <div className="text-center">
// // //             {/* Profile Section */}
// // //             <div className="flex flex-col items-center mb-8">
// // //               <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
// // //                 <FaUserCircle className="text-7xl drop-shadow-md" />
// // //               </div>
// // //               <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
// // //                 <h1 className="text-3xl font-bold">Welcome, {studentDetails.name}</h1>
// // //                 <p className="text-lg mt-1">{studentDetails.role}</p>
// // //               </div>
// // //             </div>

// // //             {/* Statistics Section */}
// // //             {loading ? (
// // //               <p className="text-center text-gray-700">Loading data...</p>
// // //             ) : error ? (
// // //               <p className="text-center text-red-500">{error}</p>
// // //             ) : (
// // //               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
// // //                 <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
// // //                   <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
// // //                   <h3 className="text-lg font-semibold">Available Modules</h3>
// // //                   <p className="text-3xl font-bold">
// // //                     {visibleTopics.length + dashboardStats.assignedCases}
// // //                   </p>
// // //                 </div>

// // //                 <Link
// // //                   to="/student-dashboard/approved-assignments"
// // //                   className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block"
// // //                 >
// // //                   <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
// // //                   <h3 className="text-lg font-semibold">Approved Assignments</h3>
// // //                   <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
// // //                 </Link>

// // //                 <Link
// // //                   to="/student-dashboard/rejected-assignments"
// // //                   className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block"
// // //                 >
// // //                   <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
// // //                   <h3 className="text-lg font-semibold">Rejected Assignments</h3>
// // //                   <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
// // //                 </Link>
// // //               </div>
// // //             )}

// // //             {/* Action Cards */}
// // //             <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
// // //               <Link
// // //                 to="/student-dashboard/topic"
// // //                 className="group flex flex-col items-center justify-center gap-3 p-6
// // //                            bg-gradient-to-r from-blue-500 to-blue-400 text-white
// // //                            rounded-xl shadow-md transition-all duration-300
// // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
// // //               >
// // //                 <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // //                 <span className="text-lg font-semibold tracking-wide">My Courses</span>
// // //               </Link>

// // //               <Link
// // //                 to="/student-dashboard/courses/ongoing"
// // //                 className="group flex flex-col items-center justify-center gap-3 p-6
// // //                            bg-gradient-to-r from-green-500 to-teal-400 text-white
// // //                            rounded-xl shadow-md transition-all duration-300
// // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
// // //               >
// // //                 <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // //                 <span className="text-lg font-semibold tracking-wide">Report Generation</span>
// // //               </Link>

// // //               <Link
// // //                 to="/student-dashboard/forums"
// // //                 className="group flex flex-col items-center justify-center gap-3 p-6
// // //                            bg-gradient-to-r from-yellow-500 to-orange-400 text-white
// // //                            rounded-xl shadow-md transition-all duration-300
// // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
// // //               >
// // //                 <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // //                 <span className="text-lg font-semibold tracking-wide">Forums</span>
// // //               </Link>

// // //               <Link
// // //                 to="/student-dashboard/student-messages"
// // //                 className="group flex flex-col items-center justify-center gap-3 p-6
// // //                            bg-gradient-to-r from-purple-500 to-pink-500 text-white
// // //                            rounded-xl shadow-md transition-all duration-300
// // //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
// // //               >
// // //                 <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
// // //                 <span className="text-lg font-semibold tracking-wide">Messages</span>
// // //               </Link>
// // //             </div>
// // //           </div>
// // //         ) : (
// // //           <p className="text-center text-red-500">Access Denied. Please log in.</p>
// // //         )}
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default StudentHome;
// // // src/Components/StudentHome.js

// // import React, { useEffect, useState, useCallback } from "react";
// // import axios from "axios";
// // import { Link } from "react-router-dom";
// // import { useUser } from "../UserContext";
// // import {
// //   FaBook,
// //   FaTasks,
// //   FaChartBar,
// //   FaEnvelope,
// //   FaUserCircle,
// //   FaClipboardList,
// //   FaExclamationTriangle,
// //   FaCheckCircle,
// // } from "react-icons/fa";

// // const StudentHome = () => {
// //   const [studentDetails, setStudentDetails] = useState(null);
// //   const { user } = useUser();

// //   // Dashboard statistics
// //   const [dashboardStats, setDashboardStats] = useState({
// //     approvedAssignments: 0,
// //     rejectedAssignments: 0,
// //     assignedCases: 0,
// //   });

// //   // Topics list
// //   const [topics, setTopics] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  1) Fetch all report PDFs so we can count approved vs. rejected
// //   // ────────────────────────────────────────────────────────────────────────────
// //   const fetchPendingReports = useCallback(async () => {
// //     setLoading(true);
// //     try {
// //       const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
// //       const { data } = await axios.get(`${apiUrl}/api/get-all-report-pdf`, {
// //         params: { username: user?.username },
// //       });

// //       // Filter by status
// //       const approvedReports = data.filter((report) => report.status === "approved");
// //       const rejectedReports = data.filter((report) => report.status === "rejected");

// //       setDashboardStats((prev) => ({
// //         ...prev,
// //         approvedAssignments: approvedReports.length,
// //         rejectedAssignments: rejectedReports.length,
// //       }));
// //     } catch (err) {
// //       console.error("Error fetching reports:", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [user]);

// //   useEffect(() => {
// //     if (user?.username) {
// //       fetchPendingReports();
// //     }
// //   }, [fetchPendingReports]);

// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  2) Load Student Details from sessionStorage
// //   // ────────────────────────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     try {
// //       const userStr = sessionStorage.getItem("user");
// //       if (!userStr) return;
// //       const storedUser = JSON.parse(userStr);
// //       if (storedUser && storedUser.name) {
// //         setStudentDetails(storedUser);
// //       }
// //     } catch (err) {
// //       console.error("Error parsing user data:", err);
// //     }
// //   }, []);

// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  3) Fetch Topics Assigned to This Student
// //   // ────────────────────────────────────────────────────────────────────────────
// //   // useEffect(() => {
// //   //   const fetchTopics = async () => {
// //   //     try {
// //   //       setLoading(true);
// //   //       const userStr = sessionStorage.getItem("user");
// //   //       if (!userStr) {
// //   //         throw new Error("User not logged in");
// //   //       }
// //   //       const storedUser = JSON.parse(userStr);
// //   //       const apiUrl = process.env.REACT_APP_API_URL;
// //   //       const response = await fetch(`${apiUrl}/api/student/topics/${storedUser.id}`);
// //   //       if (!response.ok) {
// //   //         throw new Error(`HTTP error! status: ${response.status}`);
// //   //       }
// //   //       const data = await response.json();
// //   //       setTopics(data);
// //   //       setError(null);
// //   //     } catch (err) {
// //   //       console.error("Error fetching topics:", err);
// //   //       setError("Failed to load topics data.");
// //   //     } finally {
// //   //       setLoading(false);
// //   //     }
// //   //   };

// //   //   if (studentDetails && studentDetails.id) {
// //   //     fetchTopics();
// //   //   }
// //   // }, [studentDetails]);
// //   useEffect(() => {
// //   const fetchTopics = async () => {
// //     try {
// //       setLoading(true);
// //       const userStr = sessionStorage.getItem("user");
// //       if (!userStr) throw new Error("User not logged in");
// //       const storedUser = JSON.parse(userStr);

// //       const apiUrl = process.env.REACT_APP_API_URL;
// //       const response = await fetch(`${apiUrl}/api/student/topics/${storedUser.id}`);
// //       if (!response.ok) {
// //         throw new Error(`HTTP error! status: ${response.status}`);
// //       }
// //       const data = await response.json();

// //       // ←—— INSPECT WHAT EACH TOPIC OBJECT LOOKS LIKE
// //       console.log("Fetched topics:", data);

// //       setTopics(data);
// //       setError(null);
// //     } catch (err) {
// //       console.error("Error fetching topics:", err);
// //       setError("Failed to load topics data.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (studentDetails && studentDetails.id) {
// //     fetchTopics();
// //   }
// // }, [studentDetails]);


// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  4) Fetch Assigned “Case” Count
// //   // ────────────────────────────────────────────────────────────────────────────
// //   useEffect(() => {
// //     const fetchAssignedCases = async () => {
// //       try {
// //         const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
// //         const response = await axios.get(`${apiUrl}/api/student/assignments/case/${user.id}`);
// //         setDashboardStats((prev) => ({
// //           ...prev,
// //           assignedCases: response.data.length,
// //         }));
// //       } catch (err) {
// //         console.error("Error fetching assigned cases:", err);
// //       }
// //     };

// //     if (user?.id) {
// //       fetchAssignedCases();
// //     }
// //   }, [user]);

// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  5) Filter Out Completed Topics
// //   //     (Assumes each topic object has a field `status` with 'completed'
// //   //      for finished modules. If your API uses a boolean like `isCompleted`,
// //   //      replace this check accordingly.)
// //   // ────────────────────────────────────────────────────────────────────────────
// //   const visibleTopics = topics.filter((topic) => {
// //     return topic.status?.toLowerCase() !== "completed";
// //     // If your API uses a boolean flag instead, uncomment next line and remove above:
// //     // return !topic.isCompleted;
// //   });

// //   // ────────────────────────────────────────────────────────────────────────────
// //   //  6) Render JSX
// //   // ────────────────────────────────────────────────────────────────────────────
// //   return (
// //     <div className="flex flex-col items-center justify-center min-h-screen">
// //       <div
// //         className="w-[90%] mx-auto bg-white p-10 shadow-2xl
// //                    backdrop-blur-lg border border-gray-300 rounded-xl"
// //       >
// //         {studentDetails ? (
// //           <div className="text-center">
// //             {/* Profile Section */}
// //             <div className="flex flex-col items-center mb-8">
// //               <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
// //                 <FaUserCircle className="text-7xl drop-shadow-md" />
// //               </div>
// //               <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
// //                 <h1 className="text-3xl font-bold">Welcome, {studentDetails.name}</h1>
// //                 <p className="text-lg mt-1">{studentDetails.role}</p>
// //               </div>
// //             </div>

// //             {/* Statistics Section */}
// //             {loading ? (
// //               <p className="text-center text-gray-700">Loading data...</p>
// //             ) : error ? (
// //               <p className="text-center text-red-500">{error}</p>
// //             ) : (
// //               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
// //                 <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
// //                   <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
// //                   <h3 className="text-lg font-semibold">Available Modules</h3>
// //                   <p className="text-3xl font-bold">{visibleTopics.length}</p>
// //                 </div>

// //                 <Link
// //                   to="/student-dashboard/approved-assignments"
// //                   className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block"
// //                 >
// //                   <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
// //                   <h3 className="text-lg font-semibold">Approved Assignments</h3>
// //                   <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
// //                 </Link>

// //                 <Link
// //                   to="/student-dashboard/rejected-assignments"
// //                   className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block"
// //                 >
// //                   <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
// //                   <h3 className="text-lg font-semibold">Rejected Assignments</h3>
// //                   <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
// //                 </Link>
// //               </div>
// //             )}

// //             {/* Action Cards */}
// //             <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
// //               <Link
// //                 to="/student-dashboard/topic"
// //                 className="group flex flex-col items-center justify-center gap-3 p-6
// //                            bg-gradient-to-r from-blue-500 to-blue-400 text-white
// //                            rounded-xl shadow-md transition-all duration-300
// //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
// //               >
// //                 <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
// //                 <span className="text-lg font-semibold tracking-wide">My Courses</span>
// //               </Link>

// //               <Link
// //                 to="/student-dashboard/courses/ongoing"
// //                 className="group flex flex-col items-center justify-center gap-3 p-6
// //                            bg-gradient-to-r from-green-500 to-teal-400 text-white
// //                            rounded-xl shadow-md transition-all duration-300
// //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
// //               >
// //                 <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
// //                 <span className="text-lg font-semibold tracking-wide">Report Generation</span>
// //               </Link>

// //               <Link
// //                 to="/student-dashboard/forums"
// //                 className="group flex flex-col items-center justify-center gap-3 p-6
// //                            bg-gradient-to-r from-yellow-500 to-orange-400 text-white
// //                            rounded-xl shadow-md transition-all duration-300
// //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
// //               >
// //                 <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
// //                 <span className="text-lg font-semibold tracking-wide">Forums</span>
// //               </Link>

// //               <Link
// //                 to="/student-dashboard/student-messages"
// //                 className="group flex flex-col items-center justify-center gap-3 p-6
// //                            bg-gradient-to-r from-purple-500 to-pink-500 text-white
// //                            rounded-xl shadow-md transition-all duration-300
// //                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
// //               >
// //                 <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
// //                 <span className="text-lg font-semibold tracking-wide">Messages</span>
// //               </Link>
// //             </div>
// //           </div>
// //         ) : (
// //           <p className="text-center text-red-500">Access Denied. Please log in.</p>
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default StudentHome;
// // src/Components/StudentHome.js

// import React, { useEffect, useState, useCallback } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useUser } from "../UserContext";
// import {
//   FaBook,
//   FaTasks,
//   FaChartBar,
//   FaEnvelope,
//   FaUserCircle,
//   FaClipboardList,
//   FaExclamationTriangle,
//   FaCheckCircle,
// } from "react-icons/fa";

// const StudentHome = () => {
//   const [studentDetails, setStudentDetails] = useState(null);
//   const { user } = useUser();

//   // Dashboard statistics
//   const [dashboardStats, setDashboardStats] = useState({
//     approvedAssignments: 0,
//     rejectedAssignments: 0,
//     assignedCases: 0,
//   });

//   // Topics list
//   const [topics, setTopics] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // ────────────────────────────────────────────────────────────────────────────
//   //  1) Fetch all report PDFs so we can count approved vs. rejected
//   // ────────────────────────────────────────────────────────────────────────────
//   const fetchPendingReports = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
//       const { data } = await axios.get(`${apiUrl}/api/get-all-report-pdf`, {
//         params: { username: user?.username },
//       });

//       const approvedReports = data.filter((report) => report.status === "approved");
//       const rejectedReports = data.filter((report) => report.status === "rejected");

//       setDashboardStats((prev) => ({
//         ...prev,
//         approvedAssignments: approvedReports.length,
//         rejectedAssignments: rejectedReports.length,
//       }));
//     } catch (err) {
//       console.error("Error fetching reports:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (user?.username) {
//       fetchPendingReports();
//     }
//   }, [fetchPendingReports]);

//   // ────────────────────────────────────────────────────────────────────────────
//   //  2) Load Student Details from sessionStorage
//   // ────────────────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     try {
//       const userStr = sessionStorage.getItem("user");
//       if (!userStr) return;
//       const storedUser = JSON.parse(userStr);
//       if (storedUser && storedUser.name) {
//         setStudentDetails(storedUser);
//       }
//     } catch (err) {
//       console.error("Error parsing user data:", err);
//     }
//   }, []);

//   // ────────────────────────────────────────────────────────────────────────────
//   //  3) Fetch Topics Assigned to This Student (and console.log them)
//   // ────────────────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchTopics = async () => {
//       try {
//         setLoading(true);
//         const userStr = sessionStorage.getItem("user");
//         if (!userStr) {
//           throw new Error("User not logged in");
//         }
//         const storedUser = JSON.parse(userStr);

//         const apiUrl = process.env.REACT_APP_API_URL;
//         const response = await fetch(`${apiUrl}/api/student/topics/${storedUser.id}`);
//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }
//         const data = await response.json();

//         // 👀 INSPECT WHAT EACH TOPIC OBJECT LOOKS LIKE
//         console.log("Fetched topics:", data);

//         setTopics(data);
//         setError(null);
//       } catch (err) {
//         console.error("Error fetching topics:", err);
//         setError("Failed to load topics data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (studentDetails && studentDetails.id) {
//       fetchTopics();
//     }
//   }, [studentDetails]);

//   // ────────────────────────────────────────────────────────────────────────────
//   //  4) Fetch Assigned “Case” Count (unchanged)
//   // ────────────────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchAssignedCases = async () => {
//       try {
//         const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
//         const response = await axios.get(`${apiUrl}/api/student/assignments/case/${user.id}`);
//         setDashboardStats((prev) => ({
//           ...prev,
//           assignedCases: response.data.length,
//         }));
//       } catch (err) {
//         console.error("Error fetching assigned cases:", err);
//       }
//     };

//     if (user?.id) {
//       fetchAssignedCases();
//     }
//   }, [user]);

//   // ────────────────────────────────────────────────────────────────────────────
//   //  5) Filter Out Completed Topics
//   //
//   //  –– If each topic has `status: "completed"`, filter out those.
//   //  –– If your API uses a boolean flag (e.g. `isCompleted: true`), swap this line:
//   //        return !topic.isCompleted;
//   // ────────────────────────────────────────────────────────────────────────────
//   const visibleTopics = topics.filter((topic) => {
//     return topic.status?.toLowerCase() !== "completed";
//     // If your API uses a boolean flag instead, do:
//     // return !topic.isCompleted;
//   });

//   // ────────────────────────────────────────────────────────────────────────────
//   //  6) Render JSX
//   // ────────────────────────────────────────────────────────────────────────────
//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen">
//       <div
//         className="w-[90%] mx-auto bg-white p-10 shadow-2xl
//                    backdrop-blur-lg border border-gray-300 rounded-xl"
//       >
//         {studentDetails ? (
//           <div className="text-center">
//             {/* Profile Section */}
//             <div className="flex flex-col items-center mb-8">
//               <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
//                 <FaUserCircle className="text-7xl drop-shadow-md" />
//               </div>
//               <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
//                 <h1 className="text-3xl font-bold">Welcome, {studentDetails.name}</h1>
//                 <p className="text-lg mt-1">{studentDetails.role}</p>
//               </div>
//             </div>

//             {/* Statistics Section */}
//             {loading ? (
//               <p className="text-center text-gray-700">Loading data...</p>
//             ) : error ? (
//               <p className="text-center text-red-500">{error}</p>
//             ) : (
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
//                 <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
//                   <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
//                   <h3 className="text-lg font-semibold">Available Modules</h3>
//                   {/* ← ONLY the number of unfinished topics */}
//                   <p className="text-3xl font-bold">{visibleTopics.length}</p>
//                 </div>

//                 <Link
//                   to="/student-dashboard/approved-assignments"
//                   className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block"
//                 >
//                   <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
//                   <h3 className="text-lg font-semibold">Approved Assignments</h3>
//                   <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
//                 </Link>

//                 <Link
//                   to="/student-dashboard/rejected-assignments"
//                   className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block"
//                 >
//                   <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
//                   <h3 className="text-lg font-semibold">Rejected Assignments</h3>
//                   <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
//                 </Link>
//               </div>
//             )}

//             {/* Action Cards */}
//             <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
//               <Link
//                 to="/student-dashboard/topic"
//                 className="group flex flex-col items-center justify-center gap-3 p-6
//                            bg-gradient-to-r from-blue-500 to-blue-400 text-white
//                            rounded-xl shadow-md transition-all duration-300
//                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
//               >
//                 <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
//                 <span className="text-lg font-semibold tracking-wide">My Courses</span>
//               </Link>

//               <Link
//                 to="/student-dashboard/courses/ongoing"
//                 className="group flex flex-col items-center justify-center gap-3 p-6
//                            bg-gradient-to-r from-green-500 to-teal-400 text-white
//                            rounded-xl shadow-md transition-all duration-300
//                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
//               >
//                 <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
//                 <span className="text-lg font-semibold tracking-wide">Report Generation</span>
//               </Link>

//               <Link
//                 to="/student-dashboard/forums"
//                 className="group flex flex-col items-center justify-center gap-3 p-6
//                            bg-gradient-to-r from-yellow-500 to-orange-400 text-white
//                            rounded-xl shadow-md transition-all duration-300
//                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
//               >
//                 <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
//                 <span className="text-lg font-semibold tracking-wide">Forums</span>
//               </Link>

//               <Link
//                 to="/student-dashboard/student-messages"
//                 className="group flex flex-col items-center justify-center gap-3 p-6
//                            bg-gradient-to-r from-purple-500 to-pink-500 text-white
//                            rounded-xl shadow-md transition-all duration-300
//                            cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
//               >
//                 <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
//                 <span className="text-lg font-semibold tracking-wide">Messages</span>
//               </Link>
//             </div>
//           </div>
//         ) : (
//           <p className="text-center text-red-500">Access Denied. Please log in.</p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default StudentHome;
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useUser } from "../UserContext";
import {
  FaBook,
  FaTasks,
  FaChartBar,
  FaEnvelope,
  FaUserCircle,
  FaClipboardList,
  FaExclamationTriangle,
  FaCheckCircle,
} from "react-icons/fa";

const StudentHome = () => {
  const [studentDetails, setStudentDetails] = useState(null);
  const { user } = useUser();

  // Dashboard statistics
  const [dashboardStats, setDashboardStats] = useState({
    approvedAssignments: 0,
    rejectedAssignments: 0,
    assignedCases: 0,
  });

  // **1) NEW: Courses list → holds only “available” courses**
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ────────────────────────────────────────────────────────────
  //  2) Fetch all report PDFs (approved vs. rejected)
  // ────────────────────────────────────────────────────────────
  const fetchPendingReports = useCallback(async () => {
    setLoading(true);
    try {
      const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
      const { data } = await axios.get(`${apiUrl}/api/get-all-report-pdf`, {
        params: { username: user?.username },
      });

      const approvedReports = data.filter((report) => report.status === "approved");
      const rejectedReports = data.filter((report) => report.status === "rejected");

      setDashboardStats((prev) => ({
        ...prev,
        approvedAssignments: approvedReports.length,
        rejectedAssignments: rejectedReports.length,
      }));
    } catch (err) {
      console.error("Error fetching reports:", err);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user?.username) {
      fetchPendingReports();
    }
  }, [fetchPendingReports]);

  // ────────────────────────────────────────────────────────────
  //  3) Load Student Details from sessionStorage
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    try {
      const userStr = sessionStorage.getItem("user");
      if (!userStr) return;
      const storedUser = JSON.parse(userStr);
      if (storedUser && storedUser.name) {
        setStudentDetails(storedUser);
      }
    } catch (err) {
      console.error("Error parsing user data:", err);
    }
  }, []);

  // ────────────────────────────────────────────────────────────
  //  4) FETCH AVAILABLE COURSES (instead of “topics”)
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        setLoading(true);
        const userStr = sessionStorage.getItem("user");
        if (!userStr) {
          throw new Error("User not logged in");
        }
        const storedUser = JSON.parse(userStr);

        const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
        const response = await fetch(`${apiUrl}/api/student/courses/${storedUser.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        console.log("Fetched courses:", data);
        setCourses(data);
        setError(null);
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError("Failed to load courses data.");
      } finally {
        setLoading(false);
      }
    };

    if (studentDetails && studentDetails.id) {
      fetchCourses();
    }
  }, [studentDetails]);

  // ────────────────────────────────────────────────────────────
  //  5) Fetch Assigned “Case” Count (unchanged)
  // ────────────────────────────────────────────────────────────
  useEffect(() => {
    const fetchAssignedCases = async () => {
      try {
        const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:5001").trim();
        const response = await axios.get(`${apiUrl}/api/student/assignments/case/${user.id}`);
        setDashboardStats((prev) => ({
          ...prev,
          assignedCases: response.data.length,
        }));
      } catch (err) {
        console.error("Error fetching assigned cases:", err);
      }
    };

    if (user?.id) {
      fetchAssignedCases();
    }
  }, [user]);

  // ────────────────────────────────────────────────────────────
  //  6) RENDER JSX (use `courses.length` for “Available Modules”)
  // ────────────────────────────────────────────────────────────
  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <div
        className="w-[90%] mx-auto bg-white p-10 shadow-2xl
                   backdrop-blur-lg border border-gray-300 rounded-xl"
      >
        {studentDetails ? (
          <div className="text-center">
            {/* Profile Section */}
            <div className="flex flex-col items-center mb-8">
              <div className="bg-blue-600 text-white p-3 rounded-full mb-4">
                <FaUserCircle className="text-7xl drop-shadow-md" />
              </div>
              <div className="bg-gradient-to-r from-blue-500 to-purple-500 text-white px-8 py-3 rounded-lg shadow-md">
                <h1 className="text-3xl font-bold">Welcome, {studentDetails.name}</h1>
                <p className="text-lg mt-1">{studentDetails.role}</p>
              </div>
            </div>

            {/* Statistics Section */}
            {loading ? (
              <p className="text-center text-gray-700">Loading data...</p>
            ) : error ? (
              <p className="text-center text-red-500">{error}</p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
                <div className="stat-card bg-blue-50 border border-blue-300 text-blue-900 p-6 rounded-lg shadow-lg">
                  <FaClipboardList className="text-4xl mx-auto text-blue-600 mb-2" />
                  <h3 className="text-lg font-semibold">Available Courses</h3>
                  <p className="text-3xl font-bold">{courses.length}</p>
                </div>

                <Link
                  to="/student-dashboard/approved-assignments"
                  className="stat-card bg-green-50 border border-green-300 text-green-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-green-100 transition block"
                >
                  <FaExclamationTriangle className="text-4xl mx-auto text-green-600 mb-2" />
                  <h3 className="text-lg font-semibold">Approved Assignments</h3>
                  <p className="text-3xl font-bold">{dashboardStats.approvedAssignments}</p>
                </Link>

                <Link
                  to="/student-dashboard/rejected-assignments"
                  className="stat-card bg-red-50 border border-red-300 text-red-900 p-6 rounded-lg shadow-lg hover:shadow-xl hover:bg-red-100 transition block"
                >
                  <FaCheckCircle className="text-4xl mx-auto text-red-600 mb-2" />
                  <h3 className="text-lg font-semibold">Rejected Assignments</h3>
                  <p className="text-3xl font-bold">{dashboardStats.rejectedAssignments}</p>
                </Link>
              </div>
            )}

            {/* Action Cards */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8">
              <Link
                to="/student-dashboard/courses/ongoing"
                className="group flex flex-col items-center justify-center gap-3 p-6
                           bg-gradient-to-r from-blue-500 to-blue-400 text-white
                           rounded-xl shadow-md transition-all duration-300
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-blue-400/50"
              >
                <FaBook className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">My Courses</span>
              </Link>

              <Link
                to="/student-dashboard/report-generation"
                className="group flex flex-col items-center justify-center gap-3 p-6
                           bg-gradient-to-r from-green-500 to-teal-400 text-white
                           rounded-xl shadow-md transition-all duration-300
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-green-400/50"
              >
                <FaTasks className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">Report Generation</span>
              </Link>

              <Link
                to="/student-dashboard/forums"
                className="group flex flex-col items-center justify-center gap-3 p-6
                           bg-gradient-to-r from-yellow-500 to-orange-400 text-white
                           rounded-xl shadow-md transition-all duration-300
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-yellow-400/50"
              >
                <FaChartBar className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">Forums</span>
              </Link>

              <Link
                to="/student-dashboard/student-messages"
                className="group flex flex-col items-center justify-center gap-3 p-6
                           bg-gradient-to-r from-purple-500 to-pink-500 text-white
                           rounded-xl shadow-md transition-all duration-300
                           cursor-pointer hover:scale-105 hover:shadow-xl hover:shadow-pink-400/50"
              >
                <FaEnvelope className="text-4xl group-hover:scale-110 transition-all duration-300" />
                <span className="text-lg font-semibold tracking-wide">Messages</span>
              </Link>
            </div>
          </div>
        ) : (
          <p className="text-center text-red-500">Access Denied. Please log in.</p>
        )}
      </div>
    </div>
  );
};

export default StudentHome;
